var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = {
    'ui-button--pill': _vm.pill,
    'ui-button--block': _vm.block
  }, _obj[("ui-button--" + _vm.size)] = true, _obj[("ui-button--" + _vm.variant)] = true, _obj ),attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }